import styled from 'styled-components';

const StyledHugeText = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  overflow-x: hidden;
  &::last-child(){
    margin-bottom: 0;
  }
  .huge-text--wrap{
    padding: 0 64px;
  }
  .align--left{
    text-align: left
  }
  .align--right{
    text-align: right
  }
  p{
    width: 41.66%;
    display: inline-block;
    padding-top: 80px;
    color: ${props => props.theme.colors.grey_700};
  }
  h2{
    width: 75%;
    display: inline-block;
  }
  h2.md--title{
    width: 83.33%;
  }
  .iframe--wrap{
    position: absolute;
    width: 66.66%;
    bottom: 0;
  }
  .iframe--wrap.align--right{
    left: -16.66%;
  }
  .iframe--wrap.align--left{
    right: -16.66%;
  }
  .iframe--wrap img{
    position: relative;
    width: 100%;
    display: block;
  }
  @media screen and (max-width: 1439px){
    .huge-text--wrap{
      padding: 0 40px;
    }
  }
  @media screen and (max-width: 1023px){
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    p{
      padding-top: 40px;
    }
  }
  @media screen and (max-width: 767px){
    h2{
      width: auto;
    }
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    p{
      width: 100%;
    }
    .huge-text--wrap{
      padding: 0 24px;
    }
    .iframe--wrap img{
      display: none;
    }
  }
`;

export {
  StyledHugeText,
};

